import { render, staticRenderFns } from "./comp-3.vue?vue&type=template&id=3016f593"
import script from "./comp-3.vue?vue&type=script&lang=js"
export * from "./comp-3.vue?vue&type=script&lang=js"
import style0 from "./comp-3.vue?vue&type=style&index=0&id=3016f593&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports